import * as React from 'react';

import {
    Props,
} from 'one-ui';

export interface SingleValueProps extends Props {
    value: string;
}

export const SingleValue = ({
    value,
}: SingleValueProps) => (
        <div className="values__value" >
            {value}
        </div>
    );
